import { useEffect } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DarkModeState {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  setDarkMode: (isDark: boolean) => void;
}

export const useDarkMode = create<DarkModeState>()(
  persist(
    (set) => ({
      isDarkMode: true,
      toggleDarkMode: () =>
        set((state) => {
          const newMode = !state.isDarkMode;
          updateDocumentClass(newMode);
          return { isDarkMode: newMode };
        }),
      setDarkMode: (isDark: boolean) => {
        set({ isDarkMode: isDark });
        updateDocumentClass(isDark);
      },
    }),
    {
      name: 'dark-mode-storage',
    },
  ),
);

function updateDocumentClass(isDark: boolean) {
  if (isDark) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

// Initialize dark mode on mount
export function useDarkModeInit() {
  const isDarkMode = useDarkMode((state) => state.isDarkMode);

  useEffect(() => {
    updateDocumentClass(isDarkMode);
  }, [isDarkMode]);
}
